import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { JornalService } from 'src/app/services/jornal.service';
import { obterUltimaEdicao, obterUltimaEdicaoFailure, obterUltimaEdicaoSuccess } from '../../actions/Jornal/obter-ultima-edicao.action';

@Injectable()
export class ObterUltimaEdicaoEffects {

  public obterUltimaEdicao$: unknown;

  constructor(private actions$: Actions,
    private jornalService: JornalService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterUltimaEdicao$ = createEffect(() => this.actions$.pipe(
      ofType(obterUltimaEdicao),
      switchMap(() =>
        this.jornalService
          .ObterUltimaEdicao()
          .pipe(
            map(
              response => {
                if (response.erros != undefined && response.erros.length > 0) {
                  return obterUltimaEdicaoFailure({ response })
                }
                return obterUltimaEdicaoSuccess({ response })
              }),
            catchError(() => {
              return of()
            }
            )
          )
      )
    )
    );
  }
}
